import type { FreeFormApiQuestionType, FreeFormConfigQuestion, FreeFormQuestionJson, FreeFormQuestionType } from '../types/free-form';
const CONFIG_TO_API_QUESTION_TYPE: Record<FreeFormQuestionType, FreeFormApiQuestionType> = {
  text: 'FreeText',
  textArea: 'TextArea',
  radio: 'Radio',
  checkbox: 'Checkbox'
};
const API_TO_CONFIG_QUESTION_TYPE: Record<FreeFormApiQuestionType, FreeFormQuestionType> = {
  FreeText: 'text',
  TextArea: 'textArea',
  Radio: 'radio',
  Checkbox: 'checkbox'
};

/** draft / API の freeForm.questions を設定 UI 用に変換する */
export function mapJsonQuestionsToConfigQuestions(questions: FreeFormQuestionJson[]): FreeFormConfigQuestion[] {
  return [...questions].sort((a, b) => a.displayOrder - b.displayOrder).map(question => ({
    id: question.stableKey,
    type: API_TO_CONFIG_QUESTION_TYPE[question.questionType],
    title: question.label,
    description: question.description ?? '',
    required: question.required,
    options: (question.options ?? []).map(option => ({
      id: option.value,
      label: option.label,
      ...(option.allowFreeText ? {
        isOther: true
      } : {})
    }))
  }));
}

/** 設定 UI の設問を draft / API JSON 形へ変換する */
export function mapConfigQuestionsToJson(questions: FreeFormConfigQuestion[]): FreeFormQuestionJson[] {
  return questions.map((question, index) => ({
    stableKey: question.id,
    questionType: CONFIG_TO_API_QUESTION_TYPE[question.type],
    label: question.title,
    ...(question.description ? {
      description: question.description
    } : {}),
    required: question.required,
    displayOrder: index,
    options: question.type === 'text' || question.type === 'textArea' ? null : question.options.map(option => ({
      value: option.id,
      label: option.label,
      ...(option.isOther ? {
        allowFreeText: true
      } : {})
    }))
  }));
}